import { render, staticRenderFns } from "./CalificacionCentralizadorLayout.vue?vue&type=template&id=79c52478&scoped=true"
import script from "./CalificacionCentralizadorLayout.vue?vue&type=script&lang=js"
export * from "./CalificacionCentralizadorLayout.vue?vue&type=script&lang=js"
import style0 from "./CalificacionCentralizadorLayout.vue?vue&type=style&index=0&id=79c52478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c52478",
  null
  
)

export default component.exports